import { fourierConfig as config } from "../fourier/config";
import { FourierTrail } from "../fourier/components/FourierTrail";
import { SplitFourierScene } from "../fourier/components/SplitFourierScene";
import { invaderModel } from "../fourier/invaderModel";
import { epicycles, toSvgPath, visibleTrail } from "../fourier/math/epicycles";
import { drawingProgress } from "./hookTiming";

export const hookStage = invaderModel.stages[3];
export const getDrawing = (frame: number) => {
  const progress = drawingProgress(frame);
  const chain = epicycles(hookStage.coefficients, invaderModel.dc, progress);
  const tip = chain[chain.length - 1].tip;
  return {
    chain,
    tip,
    path: toSvgPath(visibleTrail(hookStage.trail, progress, tip)),
  };
};
export const SceneDefs = () => (
  <defs>
    <filter id="trail-glow" x="-40%" y="-40%" width="180%" height="180%">
      <feGaussianBlur stdDeviation={5 / config.layout.scale} />
    </filter>
    <filter id="tip-glow" x="-200%" y="-200%" width="500%" height="500%">
      <feGaussianBlur stdDeviation={6 / config.layout.scale} />
    </filter>
    <filter id="impact-glow" x="-100%" y="-100%" width="300%" height="300%">
      <feGaussianBlur stdDeviation={12} />
    </filter>
  </defs>
);
export const HookScene = ({
  frame,
  chainOpacity = 1,
  traceOpacity = 1,
  penOpacity = chainOpacity,
}: {
  frame: number;
  chainOpacity?: number;
  traceOpacity?: number;
  penOpacity?: number;
}) => {
  const { chain, path } = getDrawing(frame);
  return (
    <>
      <SplitFourierScene
        chain={chain}
        path=""
        circleOpacity={chainOpacity}
        tipOpacity={0}
      />
      {penOpacity > chainOpacity && (
        <g
          transform={`translate(${config.layout.x} ${config.layout.y}) scale(${config.layout.scale})`}
        >
          <FourierTrail
            path=""
            tip={chain[chain.length - 1].tip}
            opacity={penOpacity - chainOpacity}
          />
        </g>
      )}
      <g
        transform={`translate(${config.layout.targetX} ${config.layout.y}) scale(${config.layout.scale})`}
      >
        <FourierTrail
          path={path}
          tip={chain[chain.length - 1].tip}
          opacity={traceOpacity}
        />
      </g>
    </>
  );
};
